import { render, staticRenderFns } from "./LazyLoadingHierchy.vue?vue&type=template&id=23b315e7&"
import script from "./LazyLoadingHierchy.vue?vue&type=script&lang=js&"
export * from "./LazyLoadingHierchy.vue?vue&type=script&lang=js&"
import style0 from "./LazyLoadingHierchy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports